// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"6c98eddcfab0339ee125","452":"0dc1492ad851e35ff0fd","453":"83e6df2318362891fbe8","454":"9cd3306868733e1620ae","551":"27105ab8af1a933161d1"}[chunkId] + ".js";
};